module.exports = __webpack_public_path__ + "static/media/HarveyWaroonaReporter-devicecomp-min.daf39ccf.png";